import axios from "axios";
import qs from "qs";
import i18n from "i18next";
import { keycloakService } from "./authService";
import { toast } from "react-toastify";
import { ApiService } from "enums/Api";

const calculateSystemName = (url) => {
  const matchedEndpoint = Object.keys(ApiService).find((endpoint) =>
    url.includes(endpoint)
  );

  return matchedEndpoint ? ApiService[matchedEndpoint] : "U-verify";
};

const apiInputService = axios.create({
  baseURL: process.env.REACT_APP_INPUT_CORE,
  headers: {
    "Content-Type": "application/json",
  },
});

apiInputService.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("accessToken");
    let subscription = localStorage.getItem("subscription");

    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    config.params = {
      ...config.params,
      subscription: subscription,
    };

    config._timeout = setTimeout(() => {
      toast.info(
        i18n.t("default-timeout-exceeded", {
          ns: "list-messages",
          SYSTEM_NAME: calculateSystemName(config.url),
        }),
        { toastId: "default-timeout-exceeded" }
      );
    }, 20000);

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

apiInputService.interceptors.response.use(
  (response) => {
    if (response.config._timeout) {
      clearTimeout(response.config._timeout);
    }
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;

      const refreshToken = localStorage.getItem("refreshToken");
      const body = qs.stringify({
        client_id: process.env.REACT_APP_API_AUTH_CLIENT_ID,
        refresh_token: refreshToken,
        grant_type: "refresh_token",
        client_secret: process.env.REACT_APP_API_AUTH_CLIENT_SECRET,
      });

      keycloakService.post("/token", body).then((response) => {
        const { access_token } = response.data;

        localStorage.setItem("accessToken", access_token);
        localStorage.setItem("refreshToken", response.data.refresh_token);

        keycloakService.defaults.headers[
          "Authorization"
        ] = `Bearer ${access_token}`;
      });
      return apiInputService(prevRequest);
    }

    if (prevRequest._timeout) {
      clearTimeout(prevRequest._timeout);
    }
    return Promise.reject(error);
  }
);

export default apiInputService;
